export interface MotivoDTO{    
    Reason: string,     
    TipoMotivo:string,
    Texto:string,
}

export function MotivoProducto(): Array<MotivoDTO> {
    let ListMotivos = new Array<MotivoDTO>();
    ListMotivos = [{Reason:"S1",TipoMotivo:"P",Texto:"La investigación se realizó fuera del país y usted ha incluido a la ESPOL como Institución de filiación."},
                   {Reason:"S2",TipoMotivo:"A",Texto:"El producto resulta de un trabajo relacionado a vínculos o docencia."},
                   {Reason:"S4",TipoMotivo:"U",Texto:"La investigación se realizó dentro o fuera del país y usted no incluyo a la ESPOL como Institución de filiación."},
                   {Reason:"S5",TipoMotivo:"O",Texto:"Otros."}];    
    return ListMotivos;
  } 